import deDE from 'locales/deDE.json';
import enUS from 'locales/enUS.json';
import { AppLocale } from './types';

export type TranslationKey = keyof typeof deDE;

export const LOCALE_KEY = 'locale';

export const getAppLocaleValue: Record<AppLocale, string> = {
  [AppLocale.en_US]: 'en-US',
  [AppLocale.de_DE]: 'de-DE'
};

export const locales = {
  [AppLocale.en_US]: enUS as object,
  [AppLocale.de_DE]: deDE as object
};
